import type { ReactNode } from 'react';
import { usePageLayout, type Product } from '@libs/common-next';
import { notFound } from 'next/navigation';
import { useCurrentRefinements, useInstantSearch } from 'react-instantsearch';

type AlgoliaNoResultsBoundaryProps = {
    children: ReactNode;
    products: Product[];
    isCategoryActive: boolean;
};

export default function AlgoliaNoResultsBoundary({
    children,
    products,
    isCategoryActive,
}: AlgoliaNoResultsBoundaryProps) {
    const { results } = useInstantSearch();
    const { items } = useCurrentRefinements();
    const { flags } = usePageLayout();

    // Current date is outside of category date range
    if (
        !results.__isArtificial &&
        !isCategoryActive &&
        flags.categoriesTimeframeEnabled
    ) {
        console.info(`[PLP] 404: Category is inactive.`);
        return notFound();
    }

    const noResult = items.length === 0 && products.length === 0;

    // the `__isArtificial` flag makes sure not to display
    // not found page when promise has not been completed
    if (!results.__isArtificial && noResult) {
        console.info(`[PLP] 404: Category did not return product results.`);
        return notFound();
    }

    return children;
}
